import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import VisitTracker from "@/components/VisitTracker";
import FloatingCallButton from "@/components/FloatingCallButton";
import RadioWavesBackground from "@/components/RadioWavesBackground";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col rm-bg-pattern relative">
      <RadioWavesBackground />
      <ScrollToTop />
      <VisitTracker />
      <div className="relative z-10 flex flex-col flex-grow">
        <Navbar />
        <main className="flex-grow">
          <Outlet />
        </main>
        <Footer />
      </div>
      <FloatingCallButton />
      <CookieBanner />
      <Toaster position="top-right" richColors />
    </div>
  );
}
